export * from './transbsk.component';
